import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
export default {
  name: 'movie_nav_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  filters: {
    typeFilter: function typeFilter(v) {
      return {
        movie: '影片',
        ciname: '影院',
        coming: '待映'
      }[v];
    }
  },
  components: {
    draggable: draggable
  },
  methods: {
    changeSwitch: function changeSwitch() {
      this.$refs.form.validate();
    },
    checkList: function checkList(rule, value, callback, status) {
      var maxLen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
      if (status && (value.length < 1 || value.length > maxLen)) {
        callback("\u540D\u79F0\u957F\u5EA6\u5E94\u4E3A1-".concat(maxLen, "\u4E2A\u5B57\u7B26"));
      }
      if (this.value.config.value.some(function (i) {
        return i.status == true;
      })) {
        callback();
      } else {
        callback('至少展示一个分类');
      }
    }
  },
  created: function created() {
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({
      category_id: '',
      value: [{
        name: '影院',
        type: 'ciname',
        status: true
      }, {
        name: '热映',
        type: 'movie',
        status: true
      }, {
        name: '待映',
        type: 'coming',
        status: true
      }]
    }, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['movie'].includes(i.type);
      });
    }
  }
};